var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"diffTime"},[_vm._v("直播倒计时: "+_vm._s(_vm.showTime))])
}
var staticRenderFns = []

export { render, staticRenderFns }